import NavigationLayout from "../navigation/navigationLayout";
import FooterLayout from "../footer/footerLayout";
import ContactView from "./contactView";
import { useEffect } from "react";

const ContactUsLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <ContactView />

            <FooterLayout needCloudTop={false}/>
        </>
    );
}

export default ContactUsLayout;